"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledImage = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 120px;\n  width: 100%;\n  background-repeat: no-repeat;\n  background-image: url(\"", "\");\n  background-position: center top;\n  background-size: contain;\n"])), function (props) {
  return props.image;
});

var ContestPicksAvatar = function ContestPicksAvatar(_ref) {
  var avatar = _ref.avatar;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImage, {
    image: avatar
  });
};

var _default = ContestPicksAvatar;
exports.default = _default;